var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-row',[_c('el-col',{attrs:{"xs":{ span: 24, offset: 0 },"sm":{ span: 16, offset: 4 },"lg":{ span: 12, offset: 6 },"xl":{ span: 8, offset: 8 }}},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }